import { render, staticRenderFns } from "./infor.vue?vue&type=template&id=4d7fa216&scoped=true"
import script from "./infor.vue?vue&type=script&lang=ts"
export * from "./infor.vue?vue&type=script&lang=ts"
import style0 from "./infor.vue?vue&type=style&index=0&id=4d7fa216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7fa216",
  null
  
)

export default component.exports